import { Model } from '@models'
import { unlessEventHasSelectedDate } from '@src/models/utils'

import CREATE_MEASUREMENT from '../graphql/createMeasurement'
import DELETE_MEASUREMENT from '../graphql/deleteMeasurement'
import { transformHistoryOrEventItem } from '../../../transforms/eventAndHistoryItemTransform'

const measurementsCacheClearPayload = (response) => ({ includeDates: [response.occurredAt] })

export default class Measurements {
  namespace = 'measurements'

  state = {
    ...Model.defaultState,
    lastMeasurementType: null,
  }

  effects = {
    submit: Model.buildEffect({
      name: `${this.namespace}/submit`,
      optimistic: true,
      query: CREATE_MEASUREMENT,
      dataPath: 'createMeasurement',
      optimisticReducers: [
        { name: 'events/backup', storePath: 'events' },
        {
          name: 'events/appendOrReplaceList',
          storePath: 'events',
          unless: unlessEventHasSelectedDate,
          transform: transformHistoryOrEventItem,
        },
        {
          name: 'dailyMeasurements/saveAvailableMeasurement',
          unless: (event) => !event.isDailyMeasurement,
          transform: transformHistoryOrEventItem,
        },
        {
          name: 'updateLastMeasurementType',
          payload: (_, { effectPayload }) => effectPayload.type,
        },
      ],
      reducers: [
        {
          name: 'events/appendOrReplaceList',
          replaceFake: true,
          storePath: 'events',
          transform: transformHistoryOrEventItem,
          unless: unlessEventHasSelectedDate,
        },
        {
          name: 'dailyMeasurements/saveAvailableMeasurement',
          unless: (event) => !event.isDailyMeasurement,
          transform: transformHistoryOrEventItem,
        },
        { name: 'dailyCharts/fetch' },
      ],
      errorReducers: [{ name: 'events/restore', storePath: 'events' }],
      cacheReducers: [
        {
          name: 'events/cacheClear',
          payload: { ...measurementsCacheClearPayload, matchName: 'events/fetch' },
        },
        {
          name: 'insights/cacheClear',
          payload: measurementsCacheClearPayload,
        },
      ],
    }),

    delete: Model.buildEffect({
      name: `${this.namespace}/deleteMeasurement`,
      optimistic: true,
      query: DELETE_MEASUREMENT,
      dataPath: 'deleteMeasurement',
      variables: (payload) => ({ id: payload.id }),
      optimisticReducers: [
        { name: 'events/backup', storePath: 'events' },
        { name: 'events/deleteList', storePath: 'events' },
      ],
      reducers: [{ name: 'dailyCharts/fetch' }],
      errorReducers: [{ name: 'events/restore', storePath: 'events' }],
      cacheReducers: [
        {
          name: 'events/cacheClear',
          payload: { ...measurementsCacheClearPayload, matchName: 'events/fetch' },
        },
        {
          name: 'insights/cacheClear',
          payload: measurementsCacheClearPayload,
        },
      ],
    }),
  }

  reducers = {
    ...Model.defaultReducers,
    updateLastMeasurementType: this.updateLastMeasurementType,
  }

  updateLastMeasurementType(state, action) {
    return { ...state, lastMeasurementType: action.payload }
  }
}
